export default "__VITE_ASSET__DaVImKU7__"